export default "__VITE_ASSET__CoNM7Y87__"